import React, { useState } from 'react';
import { StyleSheet, ScrollView } from 'react-native';
import { Portal, Modal, Colors, TouchableRipple } from 'react-native-paper';
import Icon from 'react-native-vector-icons/Ionicons'

import { pixelDimensions } from '../../config/utils';
import AppText from './AppText';

const AppSelector = ({
    containerStyle,
    options, optionValue, optionText,
    fieldValue, changeData, target,
    emptyText
}) => {
    const [ selectorShow, changeShow ] = useState(false);
    const handlePress = value => {
        changeShow(false);
        changeData( target, value );
    }
    return (
        <>
            <Portal>
                <Modal onRequestClose={ ()=>changeShow(false) } visible={selectorShow} onDismiss={()=>changeShow(false)} transparent={true} animationType={'fade'} contentContainerStyle={styles.modalContent}  >
                    <ScrollView>
                        {
                            options && options.map( (item, index) => (
                                <TouchableRipple rippleColor={Colors.indigo700} key={`option-item-${index}`} onPress={ ()=>handlePress( item[optionValue] ) }>
                                    <AppText style={styles.option}>{item[optionText]}</AppText>
                                </TouchableRipple>
                            ))
                        }
                    </ScrollView>
                </Modal>
            </Portal>
            <TouchableRipple rippleColor={Colors.indigo700} style={[styles.pressable, containerStyle]} onPress={()=>changeShow(true)}><>
                <AppText style={ styles.text }>
                    { (fieldValue === '' || fieldValue === undefined) ? (emptyText || 'Selecione...') : (options && options.filter( item => item[optionValue] === fieldValue )[0][optionText]) }
                </AppText>
                <Icon name='chevron-down-outline' style={styles.icon} />
            </></TouchableRipple>
        </>
    )
}

const styles = StyleSheet.create({
    icon: {
        fontSize: pixelDimensions(10),
        top: 0,
        position: 'absolute', 
        color: Colors.grey500,
        right: pixelDimensions(2.5),
    },
    modalContent: {
        paddingVertical: pixelDimensions(5),
        backgroundColor: Colors.white,
        margin: pixelDimensions(5),
        maxHeight: pixelDimensions(100)
    },
    option: {
        paddingHorizontal: pixelDimensions(5),
        paddingVertical: pixelDimensions(2),
        fontSize: pixelDimensions(5),
        color: Colors.black,
    },
    pressable: {
        paddingVertical: pixelDimensions(3),
        paddingHorizontal: pixelDimensions(4),
        marginBottom: pixelDimensions(2),
        borderColor: Colors.grey500,
        borderWidth: 1,
        backgroundColor: Colors.white,
    },
    text: {
        fontFamily: 'MMedium',
        fontSize: pixelDimensions(4),
    }
})

export default AppSelector;
